import React from "react";
import { RequestState } from "src/models/RequestState";
import { Dialog } from "./Dialog";
import { css } from "aphrodite-jss";
import { styles } from "./CPGenericDialogStyles";
import axios from "axios";
import { URLBuilder } from "src/core/URLBuilder";
import { JsonConvert } from "json2typescript";
import { CurrentPendingGenericData } from "src/models/CurrentPendingGenericData";
import { CPGenericItem } from "src/models/CPGenericItem";
import { Participant } from "src/models/Participant";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload} from '@fortawesome/free-solid-svg-icons'
import fileDownload from 'js-file-download'
import {json2csv} from 'json-2-csv'
import  millify from 'millify';

interface ICPGenricDialogProps {
    author_id: string;
    first_name: string;
    last_name: string;
    isOpen: boolean;
    onClose: ()=>void
}

class CPGenericDialogState {
    public readonly requestState: RequestState = RequestState.NOT_ASKED;
    public readonly error: string = "";
    public readonly data: CurrentPendingGenericData = new CurrentPendingGenericData();
}


export class CPGenericDialog extends React.Component<ICPGenricDialogProps, CPGenericDialogState> {

    constructor(props: ICPGenricDialogProps) {
        super(props);
        this.state = new CPGenericDialogState();
    }
    
    public async componentDidUpdate(prevProps: ICPGenricDialogProps){
        if(this.props.isOpen !== prevProps.isOpen  && this.props.isOpen === true) {
            //if author id is not empty and is not equal to previous author id
            axios.get(URLBuilder.current_pending(this.props.author_id)).then((res)=>{
                if(res.status === 200){
                    const jsonConvert: JsonConvert = new JsonConvert();
                    try{
                        console.log(res.data)
                        const cpData = jsonConvert.deserialize(res.data, CurrentPendingGenericData);
                        this.setState({...this.state,requestState: RequestState.SUCCESS, data: cpData})
                    }catch(err){
                        console.log(err.toString())
                        this.setState({...this.state, requestState: RequestState.ERROR, error: err.toString()})
                    }
                }else{
                    this.setState({...this.state, requestState: RequestState.ERROR, error: res.statusText})
                }
            })
        }
    }

    public render() {
        
        let content;

        if(this.state.requestState === RequestState.SUCCESS){
            content = (
                <React.Fragment>
                    <div id="container" className={css(styles.container)} >  
                        <div id="title_container" className={css(styles.titleContainer)} >
                            <h2>
                                Current
                            </h2>
                            <div onClick={this.onDownloadDataClick} className={css(styles.icon)} title={"Download data"} >
                                <FontAwesomeIcon icon={faDownload} />
                            </div>
                        </div>
                        
                        <div id='current_list' >
                            {this.state.data.current.map(this.buildItem)}
                        </div>
                        <h2>
                            Pending
                        </h2>
                        <div id="pending_list">
                            {this.state.data.pending.map(this.buildItem)}
                        </div>
                    </div>
                </React.Fragment>
            ) 
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div id="container" className={css(styles.container)}  >
                    {this.state.error}
                </div>
            )
        }else if(this.state.requestState === RequestState.LOADING){
            content = (
                <div id='container' className={css(styles.container)}  >
                    Loading
                </div>
            )
        }else {
            content = (
                <div id="container" className={css(styles.container)} >
                    Not Asked
                </div>
            )
        }

        return (
            <Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
                {content}
            </Dialog>
        )
    }

    private buildItem = (item:CPGenericItem, index: number) => {
        const PI = new Participant();
        PI.first_name = this.props.first_name;
        PI.last_name = this.props.last_name;
        PI.id = this.props.author_id;
        PI.ud_flag = true;

        const participants = [...item.participants];
        participants.unshift(PI)
        return (
            <div id={index.toString()} key={index.toString()} className={css(styles.item_container)}>
                <div id="index" className={css(styles.index)} >
                    {index + 1}.
                </div>
                <div>
                    <div id="title" className={css(styles.title)}  >
                        {item.title}
                    </div>
                    <div id="participants" className={css(styles.participantsContainer)}  >
                        {participants.map((participant: Participant, index_particpant:number)=>{
                            return this.buildParticipant(participant,index_particpant, participants.length)
                        })}
                    </div>
                    <div id="amount_container" className={css(styles.amountContainer)} >
                        <div className={css(styles.label)} >
                            Amount: 
                        </div>
                        <div>
                            {"$" + millify(item.amount)}
                        </div>
                    </div>
                    <div id="year_container" className={css(styles.yearContainer)}  >
                        <div className={css(styles.label)} >
                            Year:
                        </div>
                        <div>
                            {item.begin_year} - {item.end_year}
                        </div>
                    </div>
                    <div id="sponsor_container" className={css(styles.sponsorContainer)} >
                        <div className={css(styles.label)} >
                            Sponsor:
                        </div>
                        <div>
                            {item.sponsor}
                        </div>
                        &nbsp;
                        <div>
                            ({item.sponsor_abbr})
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    private buildParticipant = (participant: Participant, index: number, length: number) => {
        
        let content;

        let seperator;
        if(index < length - 1){
            seperator = ","
        }else{
            seperator = ""
        }

        if(participant.ud_flag){
            content = (
                <a href={`#faculty/${participant.id}`} target="_" >
                    {participant.first_name + " " + participant.last_name + seperator} &nbsp;
                </a>
            )
        }else{
            content = (
                <div>
                    {participant.first_name + " " + participant.last_name + seperator } &nbsp;
                </div>
            );
        }

        return (
            <div key={index} className={css(styles.participant)}  >
                {content}
            </div>
        )
    }

    private onDownloadDataClick = (event: any) => {
        fileDownload(JSON.stringify(this.state.data),"cp_generic.json")
    }

}


// WEBPACK FOOTER //
// ./src/components/dialogs/CPGenericDialog.tsx